import React from 'react'
import PropTypes from 'prop-types'

import { setDescription, floatToCurrency } from 'utils/utils'
import PlaceHolder from 'components/PlaceHolder'

import * as S from './styles'

const FoundCars = ({
  variation,
  adsCount,
  vehicleType,
  customization,
  placeholder,
}) => {
  const hasAds = adsCount > 0

  return (
    <S.Container variation={variation} data-test-id="found-ads">
      <S.Text>
        {hasAds && !customization && !placeholder && (
          <React.Fragment>
            <S.Title>{floatToCurrency(adsCount, 0)}</S.Title>
            {setDescription(vehicleType, adsCount)}
          </React.Fragment>
        )}
        {placeholder && (
          <S.Title>
            <PlaceHolder width="px" px="180" />
          </S.Title>
        )}
      </S.Text>
    </S.Container>
  )
}

FoundCars.defaultProps = {
  variation: null,
}

FoundCars.propTypes = {
  vehicleType: PropTypes.oneOf(['car', 'bike']).isRequired,
  adsCount: PropTypes.number.isRequired,
  variation: PropTypes.oneOf(['category']),
}

export default FoundCars
